import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
    Face6
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const Preferences = () => {
    const [age_min, setAge_min] = useState(18);
    const [age_max, setAge_max] = useState(50);
    const [distance_km, setDistance_km] = useState(500);
    const [show_me, setShow_me] = useState("");
   
    const [posting, setPosting] = useState(false);

    const navigate = useNavigate();

    const handleProceed = async () => {
       
        if (show_me === "") {
            toast.warn("Failed. Select gender you are looking for", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }

        setPosting(true);

        const userData = await JSON.parse(localStorage.getItem("userSessionData"));
        const token = userData.token;

        const dataObj = {
            age_min,
            age_max,
            distance_km,
            show_me
        }

        console.log(dataObj);
        
        const baseUrl = apilink.link;
        await axios
            .post(`${baseUrl}/preferences`, dataObj, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization" : `Bearer ${token}`
                },
            })

            .then((response) => {
                setPosting(false);
                console.log(response.data)
                navigate("/discover");
            })
            .catch((error) => {
                setPosting(false);
                console.log(error);
                console.log(error.response.data.message);
            });
    };

    return (
        <>
            <div
                style={{
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "56px",
                    paddingInline: 30,
                }}
            >
                <img
                    alt="logo"
                    style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
                    src={require("./logo.png")}
                />
                <h1
                    className="navbar-brand mb-0"
                    style={{ fontFamily: "Caveat", fontSize: 38 }}
                >
                    <b>Collide - </b> Dating
                </h1>
                <p
                    style={{
                        color: "#010832",
                        fontFamily: "Open Sans",
                        marginTop: "30px",
                    }}
                >
                    One last thing - Swipe Preferences
                </p>
                <p
                    style={{
                        color: "#00000098",
                        fontFamily: "Open Sans",
                        marginTop: "10px",
                        fontSize: "12px"
                    }}
                >
                    <center>
                        Help us help you! Pick your preferences<br />  to get better match suggestions
                    </center>
                </p>

                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        Whats your preferred age range for potential matches?
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderTop: "1px solid #010832",
                        borderLeft: "1px solid #010832",
                        borderRight: "1px solid #010832",
                        backgroundColor: "#ffffff",
                        borderTopRightRadius: 5,
                        borderTopLeftRadius: 5,
                        height: 63,
                        display: "flex",
                        flexDirection: "column",
                        paddingInline: '15px'
                    }}
                >
                    <p style={{ color: '#000000', fontSize: '10pt', marginTop: '5px' }}>Min: {age_min} Years</p>
                    <input style={{ width: "100%"}} value={age_min} onChange={(e) => { setAge_min(e.target.value) }} type="range" min="18" max="100"/>
                </div>
                <div
                    style={{
                        width: "320px",
                         borderBottom: "1px solid #010832",
                        borderLeft: "1px solid #010832",
                        borderRight: "1px solid #010832",
                        backgroundColor: "#ffffff",
                        borderBottomRightRadius: 5,
                        borderBottomLeftRadius: 5,
                        height: 63,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "column",
                        paddingInline: '15px'
                    }}
                >
                    <p style={{ color: '#000000', fontSize: '10pt', marginTop: '5px' }}>Max: {age_max} Years</p>
                    <input style={{ width: "100%"}} value={age_max} onChange={(e) => { setAge_max(e.target.value) }} type="range" min="18" max="100"/>
                </div>

                <div
                    style={{
                        width: "320px",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        Which gender are you looking for?
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Face6 style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <select
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={show_me}
                            onChange={(e) => {setShow_me(e.target.value) }}
                        >
                            <option value="" disabled selected></option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="everyone">Everyone</option>
                        </select>
                    </div>
                    <div></div>
                </div>

                <div
                    style={{
                        width: "320px",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        Within what distance are you open to finding potential matches?
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        border: "1px solid #010832",
                        borderRadius: 5,
                        height: 63,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "column",
                        paddingInline: '15px'
                    }}
                >
                    <p style={{ color: '#000000', fontSize: '10pt', marginTop: '5px' }}>Distance: {distance_km} Kilometers</p>
                    <input style={{ width: "100%"}} value={distance_km} onChange={(e) => { setDistance_km(e.target.value) }} type="range" min="0" max="2000"/>
                </div>
          
                <button
                    onClick={() => handleProceed()}
                    style={{
                        width: "320px",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        border: "none",
                        height: 50,
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        marginBottom: 25,
                        color: "white",
                        marginTop: "10px",
                    }}
                >
                    {posting === false && <>Start Swiping</>}
                    {posting && (
                        <>
                            <Squares />
                        </>
                    )}
                </button>

                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </div>
        </>
    );
};

export default Preferences;
